import request from '@/utils/request';
export function adminDel(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/distribution/admin/delete',
    method: 'GET',
    params: data
  });
}
export function adminInfo(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/distribution/admin/info',
    method: 'GET',
    params: data
  });
}
export function adminList(params) {
  return request({
    url: '/admin/distribution/admin/list',
    method: 'GET',
    params: params
  });
}

// 淘客门店管理员专用接口：不经过商户管理员路径。
export function distributionAdminList(params) {
  return request({
    url: '/admin/distribution/admin/list',
    method: 'GET',
    params: params
  });
}
export function distributionAdminAdd(pram) {
  return request({
    url: '/admin/distribution/admin/save',
    method: 'POST',
    data: {
      account: pram.account,
      pwd: pram.pwd,
      realName: pram.realName,
      roles: Array.isArray(pram.roles) ? pram.roles.join(',') : pram.roles,
      status: pram.status,
      phone: pram.phone,
      platType: 2,
      storeId: pram.storeId
    }
  });
}
export function distributionAdminUpdate(pram) {
  return request({
    url: '/admin/distribution/admin/update',
    method: 'POST',
    data: {
      id: pram.id,
      account: pram.account,
      realName: pram.realName,
      roles: Array.isArray(pram.roles) ? pram.roles.join(',') : pram.roles,
      status: pram.status,
      phone: pram.phone
    }
  });
}
export function distributionAdminDel(params) {
  return request({
    url: '/admin/distribution/admin/delete',
    method: 'GET',
    params: {
      id: params.id
    }
  });
}
export function distributionAdminUpdateStatus(params) {
  return request({
    url: '/admin/distribution/admin/updateStatus',
    method: 'GET',
    params: params
  });
}
export function distributionAdminUpdateReceiveSms(id) {
  return request({
    url: '/admin/distribution/admin/update/receive/sms/' + id,
    method: 'POST'
  });
}
export function distributionAdminUpdatePassword(data) {
  return request({
    url: '/admin/distribution/admin/update/password',
    method: 'POST',
    data: data
  });
}
export function adminAdd(pram) {
  var data = {
    account: pram.account,
    level: pram.level,
    pwd: pram.pwd,
    realName: pram.realName,
    roles: pram.roles.join(','),
    status: pram.status,
    phone: pram.phone
  };
  return request({
    url: '/admin/distribution/admin/save',
    method: 'POST',
    data: data
  });
}
export function adminUpdate(pram) {
  var data = {
    account: pram.account,
    phone: pram.phone,
    pwd: pram.pwd,
    realName: pram.realName,
    id: pram.id,
    roles: pram.roles,
    status: pram.status
  };
  return request({
    url: '/admin/distribution/admin/update',
    method: 'POST',
    data: data
  });
}

/**
 * 修改状态
 * @param pram
 */
export function updateStatusApi(params) {
  return request({
    url: "/admin/distribution/admin/updateStatus",
    method: 'get',
    params: params
  });
}

/**
 * 修改后台管理员是否接收状态
 * @param pram
 */
export function updateIsSmsApi(params) {
  return request({
    url: "/admin/merchant/admin/update/isSms",
    method: 'get',
    params: params
  });
}

/**
 * 敏感操作日志分页列表
 * @param data
 */
export function sensitiveListApi(params) {
  return request({
    url: "/admin/merchant/log/sensitive/list",
    method: 'get',
    params: params
  });
}

/**
 * 修改登录用户信息
 * @param data
 */
export function adminAccountUpdate(pram) {
  var data = {
    realName: pram.realName
  };
  return request({
    url: '/admin/distribution/login/admin/update',
    method: 'POST',
    data: data
  });
}

/**
 * 修改登录用户密码
 * @param data
 */
export function adminPasswordUpdate(pram) {
  var data = {
    confirmPassword: pram.confirmPassword,
    password: pram.password,
    oldPassword: pram.oldPassword
  };
  return request({
    url: '/admin/distribution/login/admin/update/password',
    method: 'POST',
    data: data
  });
}

/**
 * 修改管理员密码
 * @param data
 */
export function editPassWordApi(data) {
  return request({
    url: '/admin/distribution/admin/update/password',
    method: 'POST',
    data: data
  });
}

/**
 * 商户后台管理员短信开关
 * @param pram
 */
export function updateReceiveSmsApi(id) {
  return request({
    url: "/admin/distribution/admin/update/receive/sms/".concat(id),
    method: 'post'
  });
}